import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const FormatQuoteOpenNewIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props} ref={ref}>
        <path
            // eslint-disable-next-line max-len
            d='M8.55279 7C9.21769 7 9.65014 7.69972 9.35279 8.29443L8 11H10C10.5523 11 11 11.4477 11 12V16C11 16.5523 10.5523 17 10 17H7C6.44772 17 6 16.5523 6 16V11L7.75279 7.49443C7.9043 7.19141 8.214 7 8.55279 7ZM15.5528 7C16.2177 7 16.6501 7.69972 16.3528 8.29443L15 11H17C17.5523 11 18 11.4477 18 12V16C18 16.5523 17.5523 17 17 17H14C13.4477 17 13 16.5523 13 16V11L14.7528 7.49443C14.9043 7.19141 15.214 7 15.5528 7Z'
            fill='currentColor'
        />
    </svg>
));
